import { defineMessages } from 'react-intl';

export default defineMessages({

    newVehicleHeading: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Add a new vehicle to your quote',
        defaultMessage: 'Add a new vehicle to your quote'
    },
    newVehicleSubTitle: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Enter your make and model details. The quoted rate may change when updating this information',
        defaultMessage: 'Enter your make and model details{br}The quoted rate may change when updating this information'
    },
    enteryourMakeModel: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Enter your make and model details',
        defaultMessage: 'Enter your make and model details'
    },
    quoteInfomayChange: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.The quoted rate may change when updating this information',
        defaultMessage: 'The quoted rate may change when updating this information'
    },
    nextWellAddDetails: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Next we\'ll add remaining details about your vehicle',
        defaultMessage: 'Next we\'ll {addRemainingDetails} about your vehicle'
    },
    addRemainingDetails: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.add remaining details',
        defaultMessage: 'add remaining details'
    },
    vehicleCategory: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Vehicle Category',
        defaultMessage: 'Vehicle Category'
    },
    addTrailer: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Should I add my trailer?',
        defaultMessage: 'Should I add my trailer?'
    },
    addTrailerTooltipContent: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Should I add my Trailer Tooltip',
        defaultMessage: 'Only vehicles that need to carry comprehensive and collision should be added. Liability coverage will be extended from the towing vehicle.'
    },
    addTrailerTooltipContentQb: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Should I add my Trailer TooltipQb',
        defaultMessage: 'Only vehicles that need to carry comprehensive and collision should be added. Liability coverage extends from the towing vehicle.'
    },
    vehicleType: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    whichvehicleType: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Which vehicle type should I select?',
        defaultMessage: 'Which vehicle type should I select?'
    },
    whichvehicleTypeTooltipContent: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Vehicle Type Tooltip Content',
        defaultMessage: 'Private Passenger/light truck if you have the following: private passenger auto, station wagon, pick-up, van, panel truck, SUV or flat-bed/box truck not requiring a commercial driver’s license. Collectible if you have a vehicle which is unique or vintage and is collectible in nature. Categories for collectible vehicles include: Antique – Vehicles which are 1) licensed as an antique with the Department of Motor Vehicles; or 2) 25 years old or older and in running condition. Vehicles may be driven only on a limited basis. Vehicles kept only for use as parts are not eligible. Classic – Vehicles that are at least 10 years old and of limited production or of rare or historic interest through being restored, maintained or preserved. These vehicles appreciate in value (from their original price new) as they become older. Replica – Reproductions of an antique or classic vehicle. Generally following the design and features of an older out of production vehicle, but manufactured and assembled with newer parts and equipment. Custom – A vehicle which has been custom built, including kit cars, or has been significantly modified from its original specifications. Trailer if you have a camping, travel or utility trailer. Low Speed Vehicle if you have a low speed vehicle or neighborhood electric vehicle (NEV). In most states, vehicles are considered low speed when they are less than 35 miles per hour. Registered Golf Carts if your golf cart is registered.'
    },
    year: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Year',
        defaultMessage: 'Year'
    },
    make: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Model',
        defaultMessage: 'Model'
    },
    modelNotListed: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Model not listed',
        defaultMessage: 'Model not listed'
    },
    myModelIsntListed: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.My model isn\'t listed',
        defaultMessage: 'My model isn\'t listed'
    },
    bodyType: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Body Type',
        defaultMessage: 'Body Type'
    },
    trim: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Trim',
        defaultMessage: 'Trim'
    },
    cylinders: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.cylinders',
        defaultMessage: 'Cylinders'
    },
    symbols: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.symbols',
        defaultMessage: 'Symbols'
    },
    simplyVIN: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.OR simply enter the VIN number',
        defaultMessage: 'OR simply enter the VIN'
    },
    simplyVINQb: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.OR simply enter the VIN numberQb',
        defaultMessage: 'OR simply add VIN'
    },
    addwithVIN: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.ADD MY VEHICLE WITH VIN',
        defaultMessage: 'ADD MY VEHICLE WITH VIN'
    },
    addwithVINBtn: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Add my vehicle with VIN',
        defaultMessage: 'Add my vehicle with VIN'
    },
    enterVIN: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.enterVIN',
        defaultMessage: 'Enter VIN'
    },
    vinResponseEnterYear: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinResponse.We are unable to validate the model year of your vehicle, please enter model year',
        defaultMessage: 'We are unable to validate the model year of your vehicle, please enter model year'
    },
    vinResponseInvalidPleaseTryAgain: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinResponse.invalidVINPleaseTryAgain',
        defaultMessage: 'Invalid VIN. Please try again.'
    },
    vinResponseInValid: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinResponse.inValidVIN',
        defaultMessage: 'VIN {vin} is invalid. Please confirm the VIN listed is accurate, then enter the Vehicle Type, Year, Make, and Model and select Lookup VIN. If the model is not listed in the dropdown, please click Model Not Listed and enter the required fields.'
    },
    actionbuttonLabelContinue: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.actionbuttonLabelContinue',
        defaultMessage: 'CONTINUE'
    },
    vinhelpTextMessage: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinHelpTextMessage',
        defaultMessage: 'A VIN (vehicle identification number) is a unique 17-digit code used by the auto industry to identify individual motor vehicles.  By entering the VIN, we can automatically validate the specifics of the vehicle and provide a more accurate car insurance quote, including applicable discounts.  The VIN can be found in several places on the vehicle including the driver’s side dashboard and driver’s side doorjamb.   You can complete a quote without the entire VIN however, the quoted rate may change when the complete VIN is entered.'
    },
    vinhelpTextHeader: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinHelpTextHeader',
        defaultMessage: 'Vehicle Identification Number Information'
    },
    vinhelpTextHeaderQb: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinHelpTextHeaderQb',
        defaultMessage: 'Vehicle Identification Information'
    },
    vinNumber: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.vinNumber',
        defaultMessage: 'VIN'
    },
    verifyVin: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.verifyVin',
        defaultMessage: 'VERIFY VIN'
    },
    LOOKUPVINBtn: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.LOOKUP VIN',
        defaultMessage: 'LOOKUP VIN'
    },
    lookupVinBtn: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.lookupVin',
        defaultMessage: 'Lookup VIN'
    },
    actionButtonLabelAddVehicle: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.actionButtonLabelAddVehicle',
        defaultMessage: 'ADD VEHICLE'
    },
    cancel: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.cancel',
        defaultMessage: 'CANCEL'
    },
    selectVehicle: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.selectVehicle',
        defaultMessage: 'Select Vehicle'
    },
    save: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.save',
        defaultMessage: 'SAVE'
    },
    symbolsMsg: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.symbolsMsg',
        defaultMessage: 'Comp: {compSymbol} {br}  Collision: {collSymbol}'
    },
    thisIsRequired: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.This is required',
        defaultMessage: 'This is required'
    },
    serialNumber: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    costNew: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.costNew',
        defaultMessage: 'Cost New'
    },
    costNewTooltipTitle: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.costNewTooltipTitle',
        defaultMessage: 'What is cost new?'
    },
    costNewTooltipText: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.costNewTooltipText',
        defaultMessage: 'Cost new is the original manufacturer’s purchase price based on the year the vehicle was made. We require you to enter the cost new in the following situations: when you do not enter a VIN when quoting; when we are unable to verify your vehicle based on the VIN entered; or when your vehicle is either brand new or a 1980 or older model.'
    },
    comprehensiveSymbol: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.comprehensiveSymbol',
        defaultMessage: 'Comprehensive Symbol'
    },
    collisionSymbol: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.collisionSymbol',
        defaultMessage: 'Collision Symbol'
    },
    labelValuePlaceholder: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.labelValuePlaceholder',
        defaultMessage: '{label}: {value}'
    },
    value: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.value',
        defaultMessage: 'Value'
    },
    valueToltipContentNH: {
        id: "ml.quoteandbind.pa.partialVehicleDetail.NH tooltip content",
        defaultMessage: "For trailers or low speed vehicles, the value is based on the cost to sell or purchase the vehicle or trailer. For classic, antique vehicles and other personally registered vehicles, the value entered should be the current market value or the vehicle appraisal value, if available.",
    },
    valueToltipContentAZ: {
        id: "ml.quoteandbind.pa.partialVehicleDetail.AZ tooltip content",
        defaultMessage: "For trailers, low speed vehicles or registered golf carts, the value is based on the cost to sell or purchase the vehicle or trailer. For classic and antique vehicles, the value entered should be the current market value or the vehicle appraisal value, if available.",
    },
    valueToltipContentRest: {
        id: "ml.quoteandbind.pa.partialVehicleDetail.Rest tooltip content",
        defaultMessage: "For trailers or low speed vehicles, the value is based on the cost to sell or purchase the vehicle or trailer. For classic and antique vehicles, the value entered should be the current market value or the vehicle appraisal value, if available.",
    },
    vehicleReplaced:{
        id:'ml.quoteandbind.pa.partialVehicleDetail.Vehicle Replace Message',
        defaultMessage:' {strongName} will be removed from the policy. Please add the replacement vehicle below.'
    },
    editVehicleHeading: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Edit vehicle',
        defaultMessage: 'Edit vehicle'
    },
    editVehicleSubTitle: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.The quoted rate may change when updating this information',
        defaultMessage: 'The quoted rate may change when updating this information'
    },
    vinInvalidCharactersError: {
        id: 'ml.gateway.quoteandbind.pa.partialVehicleDetail.vinInvalidCharactersError',
        defaultMessage: "Correct the VIN. The characters 'I', 'O', and 'Q' are not allowed in any position for vehicles with model year 1981 or later."
    },
    vinNinthCharacterError: {
        id: 'ml.gateway.quoteandbind.pa.partialVehicleDetail.vinNinthCharacterError',
        defaultMessage: "Correct the VIN. The 9th character must be a number from 0 to 9 or the letter X for vehicles with model year 1981 or later."
    },
    vinTenthCharacterError: {
        id: 'ml.gateway.quoteandbind.pa.partialVehicleDetail.vinTenthCharacterError',
        defaultMessage: "Correct VIN for Vehicle. The 10th character cannot be 'U', 'Z', or the number 0 for vehicles with model year 1981 or later."
    }
});